import React, {useEffect, FC, useState} from "react";
import {Box, BoxProps} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import { corePaths } from "@buildwitt/shapeshift-types";
import { GridLinkOperator } from "@mui/x-data-grid-pro";
import { AdminLessonsTable } from "@/components/admin/lessonTable/AdminLessonsTable";
import { AdminQuizzesTable } from "@/components/admin/quizTable/AdminQuizzesTable";
import { ICurriculumItemImportSlim } from "@/types/curriculum";
import { palette } from "@/constants";
import ModuleTypeSelect from "@/components/admin/select/ModuleTypeSelect";


interface IFilterMap {
	[type: string]: Set<number>
}

export interface ICustomProps {
	filterMap?: IFilterMap,
	typeFilter?: string,
	selected: ICurriculumItemImportSlim[],
	onChange: (newSelected: ICurriculumItemImportSlim[]) => void
}

export type IProps = ICustomProps & Omit<BoxProps, "onChange">

const useStyles = makeStyles()(
	(theme) => ({
		moduleSearch: {
		},
		typeSelectContainer:{
			flexBasis: "200px",
			flexGrow: 0
		},
		searchContainer:{
			flexBasis: 1,
			flexGrow: 2
		},
		header: {
			display: "flex",
			gap: "20px"
		},
		searchResults: {
			marginTop: "20px",
			"& tr: hover": {
				cursor: "pointer",
				background: palette.grey15
			}
		}
	})
);

const ModuleSearch: FC<IProps> = ({selected: propsSelected, filterMap, onChange, className, typeFilter, ...boxProps}) => {
	const {classes, cx} = useStyles();
	const [moduleType, setModuleType] = useState<string | undefined>(typeFilter);
	const [selectedLessonIds, setSelectedLessonIds] = useState<number[]>([]);
	const [selectedQuizIds, setSelectedQuizIds] = useState<number[]>([]);
	const [selected, setSelected] = useState<ICurriculumItemImportSlim[]>([]);

	useEffect(() => {
		onChange(selected);
	}, [selected])

	useEffect(() => {
		if(propsSelected.length !== selected.length && propsSelected.filter(e => !selected.includes(e)).length > 0) {
			setSelected(propsSelected)
		}
	}, [propsSelected]);

	//set default type
	useEffect(() => {
		if (!moduleType) {
			setModuleType(corePaths.lesson);
		}
	}, [moduleType]);

	useEffect(() => {
		setSelected([
			...selectedLessonIds.map(id => ({
			id,
			type: corePaths.lesson
		})), 
		...selectedQuizIds.map(id => ({
			id,
			type: corePaths.quiz
		}))]);
	}, [selectedLessonIds, selectedQuizIds]);

	return (
		<Box className={cx(className, classes.moduleSearch)} {...boxProps}>
			<Box className={classes.header}>
				{!typeFilter && <Box className={classes.typeSelectContainer}>
					<ModuleTypeSelect
						value={moduleType}
						onChange={e => setModuleType(e)}
					/>
				</Box>}
				{/* <Box className={classes.searchContainer}>
					<TextField
						placeholder="Search modules..."
						label="Search"
						name="module-search-input"
						onChange={e => setSearchTerm(e.target.value)}
						value={searchTerm}
					/>
				</Box> */}
			</Box>
			<Box padding={2}></Box>
			{moduleType === corePaths.lesson && <>
				<AdminLessonsTable 
					enableDelete={false}
					onEditAction={() => {}}
					extendedAccess
					searchDTOverride={(e) => ({
						...e, 
						extendedAccess: true, 
						filters: ({
							concatinator: GridLinkOperator.And, 
							conditions: [
								...(e.filters?.conditions ?? []), 
								{attribute: "id", operator: "nin" as any, value: Array.from(filterMap?.[corePaths.lesson] ?? [])}
							]
						} as any)
					})}
					isRowSelectable={(params) => {
						return !(filterMap[corePaths.lesson]?.has(params.row.id as number))}
					}
					selectionModel={selectedLessonIds}
					onSelectionModelChange={e => setSelectedLessonIds(e as number[])}
				/>
			</>}
			{moduleType === corePaths.quiz && <>
				<AdminQuizzesTable
					enableDelete={false}
					onEditAction={() => {}}
					searchDTOverride={(e) => ({
						...e, 
						extendedAccess: true, 
						filters: ({
							concatinator: GridLinkOperator.And, 
							conditions: [
								...(e.filters?.conditions ?? []), 
								{attribute: "id", operator: "nin" as any, value: Array.from(filterMap[corePaths.quiz] ?? [])}
							]
						} as any)
					})}
					isRowSelectable={(params) => {
						return !(filterMap[corePaths.quiz]?.has(params.row.id as number))}
					}
					onSelectionModelChange={e => setSelectedQuizIds(e as number[])}
				/>
			</>}
			
		</Box>
	)
}

export default ModuleSearch;